module.exports = __webpack_public_path__ + "img/switchbot.64931194.png";